import Text from "../UI/Text";
import styles from "./FieldRow.module.css";

interface FieldRowProps {
  label: string;
  value?: string | null;
}

export default function FieldRow({ label, value }: FieldRowProps) {
  if (!value) return null;
  return (
    <div className={styles.fieldRow}>
      <Text variant="deci" className={styles.fieldLabel}>
        {label}
      </Text>
      <Text variant="deci" weight="medium" className={styles.fieldValue}>
        {value}
      </Text>
    </div>
  );
}
